import { createContext } from "react";

import { type SpaInfo } from "helpers/AppProvider.types";

/**
 * Context containing information about the current app if page is SPA page (boolean)
 *
 */
export const SpaInfoContext = createContext<SpaInfo>({ isSpa: false });

export const DefaultEnabledSpaInfo = { isSpa: true };
